import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route, withRouter, Switch, BrowserRouter } from 'react-router-dom'
import Login from '../../Auth/containers/Login'
import LaridaeApp from '../../LaridaeApp/containers/LaridaeApp'
import PreIngresoCaladoA from '../../Calado/containers/preingreso/PreIngresoCaladoA'
import PreIngresoCaladoB from '../../Calado/containers/preingreso/PreIngresoCaladoB'
import PesadoDestareChofer from '../../Pesado/containers/pesadoDestareChofer/PesadoDestareChofer'
import PesadoBrutoChofer from '../../Pesado/containers/pesadoBrutoChofer/PesadoBrutoChofer'
import PoliticasDePrivacidad from '../../Camiones/containers/consultas/consultaChofer/PoliticaDePrivacidad'
import { checkUserStatus } from '../../Auth/actions'
import ConsultaChofer from '../../Camiones/containers/consultas/consultaChofer/ConsultaChofer'

class MainApp extends Component {
  componentDidMount () {
    this.props.checkUserStatus(this.props.history)
  }

  render () {
    const {
      userDataReady,
      match: { url }
    } = this.props
    if (!userDataReady) return null
    return (
      <div className='container-fluid h-100' style={{ padding: '0' }}>
        <BrowserRouter basename='/laridae'>
          <Switch>
            <Route path={`${url}login`} component={Login} />
            <Route path={`${url}preingresoCalado/1-2`} component={PreIngresoCaladoA} />
            <Route path={`${url}preingresoCalado/3-4`} component={PreIngresoCaladoB} />
            <Route path={`${url}pesadoDestare`} component={PesadoDestareChofer} />
            <Route path={`${url}pesadoBruto`} component={PesadoBrutoChofer} />
            <Route path={`${url}tqqapp/politicadeprivacidad`} component={PoliticasDePrivacidad} />
            <Route path={`${url}consultaCupo`} component={ConsultaChofer} />
            <Route path={`${url}`} component={LaridaeApp} />
          </Switch>
        </BrowserRouter>
      </div>
    )
  }
};

const mapStateToProps = (state) => ({
  userDataReady: state.auth.userDataReady
})

const withRedux = connect(mapStateToProps, { checkUserStatus })

export default withRouter(withRedux(MainApp))
